var Signal = (function () {

    var Signal = function ( owner, once ) {
        this._owner = owner || null;
        this._once = once || false;
        this._listeners = [];
    };

    Signal.prototype = {
        fire : function () {
            var len = this._listeners.length;
            for ( var i = 0; i < len; i++ ) {
                var ifn = this._listeners[ i ];
                if ( ifn ) {
                    ifn.apply( this._owner, arguments );
                }
            }
            if ( this._once ) {
                this.clean();
            }
        },
        addListener : function ( fn ) {
            var len = this._listeners.length;
            for ( var i = 0; i < len; i++ ) {
                var ifn = this._listeners[ i ];
                if ( fn === ifn ) {
                    return i;
                }
            }
            this._listeners.push( fn );
            return this._listeners.length - 1;
        },
        removeListener : function ( fn ) {
            if ( typeof fn === "number" ) {
                fn = this._listeners[ fn ];
            }
            if ( typeof fn !== "function" ) {
                return false;
            }
            var len = this._listeners.length;
            for ( var i = 0; i < len; i++ ) {
                var ifn = this._listeners[ i ];
                if ( fn === ifn ) {
                    this._listeners[ i ] = false;
                    return true;
                }
            }
            return false;
        },
        clean : function () {
            var len = this._listeners.length;
            this._listeners.length = 0;
            this._listeners.length = len;
        }
    };

    Signal.create = function ( owner, once ) {
        var res = function ( fn ) {
            return res.signal.addListener( fn );
        };
        res.fire = function () {
            res.signal.fire.apply( res.signal, arguments );
        };
        res.signal = new Signal( owner, once );
        return res;
    };

    return Signal;

})();
